module.exports = __webpack_public_path__ + "img/64.f85fd8ad.png";